import { PartFinderReport } from '@/api/generatedApi';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useTenants } from '@/services/tenants/useTenants';
import { styled } from '@mui/material/styles';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const RenderPartNumber = (parameters: GridRenderCellParams<PartFinderReport>) => {
  const { getPath } = useTenants();
  const reportPath = getPath(`part-finder-reports/${parameters.row.id}`);
  return <StyledLink to={reportPath}>{parameters.value}</StyledLink>;
};

export const RenderDescription = (parameters: GridRenderCellParams<PartFinderReport>) => {
  return parameters.row.description ?? 'none';
};

export const RenderCreator = (parameters: GridRenderCellParams<PartFinderReport>) => {
  const { selfAwareEmail } = useGetCurrentUser();
  return selfAwareEmail(parameters.row.creator?.email || '');
};

export const RenderCreatedAt = (parameters: GridRenderCellParams<PartFinderReport>) => {
  return parameters.row.createdAt ? format(new Date(parameters.row.createdAt), 'MMM d, yyyy') : '';
};
